import {formatMoney} from "@/utils";
import {
  applyCountryCurrencyCode,
  checkPaymentPhone,
  findMnoInfoByBankCode,
  formatDecimalByPlaces,
  getPaymentPhoneMaxLength,
  zeroFillPaymentPhone,
} from "@/utils/countryAdapter";
import { setLanguageByCountry } from "@/utils/languageAdapter";

export default {
  name: "pay",
  props: {
    pageData: Object,
  },
  watch: {
    pageData(val) {
      console.log("watch", val)
      this.repaymentData = val;
      this.updateCode();
      this.initOperatorList();
    }
  },
  computed: {
    //国家信息
    countryInfo() {
      return this.repaymentData?.configData?.countryInfoVO;
    },
    countryInfoLogo() {
      if (["GH"].includes(this.countryInfo?.enName)) {
        return require(`@/assets/payLogo2.png`);
      } else {
        return require(`@/assets/payLogo.png`);
      }
    },
    //还款账号长度
    phoneMaxLength() {
      return getPaymentPhoneMaxLength(this.countryInfo);
    },
    currentBankInfo() {
      const selectedOperator = this.operatorList.find((v) => v.isSelect);
      const bankCode =
        selectedOperator?.value || this.repaymentData?.paymentData?.bankCode;
      const matchedOperator = this.operatorList.find(
        (v) => String(v.value) === String(bankCode)
      );
      if (matchedOperator?.decimalPlaces != null) {
        return matchedOperator;
      }
      return findMnoInfoByBankCode(this.repaymentData, bankCode) || matchedOperator;
    },
    // 格式化后的支付金额，根据当前选中的银行 decimalPlaces 格式化
    formattedPaymentAmount() {
      const amount = this.repaymentData?.paymentData?.amount;
      if (amount == null) return amount;
      return formatDecimalByPlaces(
        String(amount),
        this.currentBankInfo?.decimalPlaces
      );
    },
  },
  data() {
    return {
      setTimeoutID: undefined,
      repaymentData: {},

      hr: undefined,
      min: undefined,
      sec: undefined,

      operator: "",
      operatorValue: "",
      operatorPopup: false,
      operatorDefaultIndex: 0,
      operatorList: [
        // {
        //     name: "WAVE",
        //     value: "BF0001",
        //     logo: require("@/assets/CI/wave.png"),
        //     isSelect: false
        // },
        // {
        //     name: "ORANGE",
        //     value: "BF0003",
        //     logo: require("@/assets/CI/orange.png"),
        //     isSelect: false
        // },
        // {
        //     name: "MOOV",
        //     value: "BF0004",
        //     logo: require("@/assets/CI/moov.png"),
        //     isSelect: false
        // },
        // {
        //     name: "TELECEL",
        //     value: "BF0002",
        //     logo: require("@/assets/CI/telecel.png"),
        //     isSelect: false
        // },
      ],

      customerName: "",
      customerBankCode: "",
      customerBankName: "",
      bankList: [],
      bankPopup: false,

      paymentAccount: "",
      userSubmitAccountNumber: "",
      userSubmitOperator: "",
      editAccountNumber: "",

      carrierSelectionShow: false,
      paymentAccountShow: false,
      editAccountShow: false,
      editAccountConfirmShow: false,
      collectionShow: false,
      collectionDetailShow: false,
      channelCheckoutUrl: "",

      collectionDataStep: -1,
      collectionData: {
        "transactionNums": 0,
        "collectedAmount": 0,
        "collectDetails": []
      },
    };
  },
  methods: {
    formatMoney,
    setLanguageBasedOnCountry(countryCode = "EN") {
      setLanguageByCountry(countryCode, this);
    },
    async getBankList() {
      if (this.countryInfo?.enName !== "TH") return;
      let res = await this.$http.v1Banks();
      if (res.code == "200" && res.data) {
        this.bankList = res.data.map(v => ({
          name: v.bankName,
          value: v.bankCode,
          isSelect: false
        }));
      }
      // const bankData = [
      //   { bankAlias: "KBANK", bankCode: "TH0001", bankIcon: "", bankName: "(KBANK)Kasikorn Bank Plc.", countryCode: "TH" },
      //   { bankAlias: "BBL", bankCode: "TH0002", bankIcon: "", bankName: "(BBL)Bangkok Bank Plc.", countryCode: "TH" },
      //   { bankAlias: "KTB", bankCode: "TH0003", bankIcon: "", bankName: "(KTB)Krung Thai Bank", countryCode: "TH" },
      //   { bankAlias: "ABN", bankCode: "TH0004", bankIcon: "", bankName: "(ABN)ABN Amro Bank N.V.", countryCode: "TH" },
      //   { bankAlias: "TTB", bankCode: "TH0005", bankIcon: "", bankName: "(TTB)TMBThanachart", countryCode: "TH" },
      //   { bankAlias: "SCB", bankCode: "TH0006", bankIcon: "", bankName: "(SCB)Siam Commercial Bank", countryCode: "TH" },
      //   { bankAlias: "UOB", bankCode: "TH0007", bankIcon: "", bankName: "(UOB)UOB Bank Plc.", countryCode: "TH" },
      //   { bankAlias: "BAY", bankCode: "TH0008", bankIcon: "", bankName: "(BAY)Bank of Ayudhya / Krungsri", countryCode: "TH" },
      //   { bankAlias: "CIMB", bankCode: "TH0009", bankIcon: "", bankName: "(CIMB)CIMB Thai Bank Public Company Limited", countryCode: "TH" },
      //   { bankAlias: "LHBANK", bankCode: "TH0010", bankIcon: "", bankName: "(LHBANK)Land and Houses Bank Public Company Limited", countryCode: "TH" },
      //   { bankAlias: "GSB", bankCode: "TH0011", bankIcon: "", bankName: "(GSB)Government Savings Bank", countryCode: "TH" },
      //   { bankAlias: "KKP", bankCode: "TH0012", bankIcon: "", bankName: "(KKP)Kiatnakin Phatra Bank Public Company Limited", countryCode: "TH" },
      //   { bankAlias: "CITI", bankCode: "TH0013", bankIcon: "", bankName: "(CITI)Citibank N.A.", countryCode: "TH" },
      //   { bankAlias: "GHB", bankCode: "TH0014", bankIcon: "", bankName: "(GHB)Government Housing Bank", countryCode: "TH" },
      //   { bankAlias: "BAAC", bankCode: "TH0015", bankIcon: "", bankName: "(BAAC)Bank for Agriculture and Agricultural Cooperatives", countryCode: "TH" },
      //   { bankAlias: "MHCB", bankCode: "TH0016", bankIcon: "", bankName: "(MHCB)Mizuho Corporate Bank Limited", countryCode: "TH" },
      //   { bankAlias: "IBANK", bankCode: "TH0017", bankIcon: "", bankName: "(IBANK)Islamic Bank of Thailand", countryCode: "TH" },
      //   { bankAlias: "TISCO", bankCode: "TH0018", bankIcon: "", bankName: "(TISCO)TISCO Bank Plc.", countryCode: "TH" }
      // ];
      // this.bankList = bankData.map(v => ({
      //   name: v.bankName,
      //   value: v.bankCode,
      //   isSelect: false
      // }));
    },
    bankChange(value) {
      this.customerBankCode = value.value;
      this.customerBankName = value.name;
      this.bankPopup = false;
    },
    realFocus(str) {
      if (str == "operator") {
        this.operatorPopup = true;
      }
    },
    operatorChange(value) {
      this.operator = value.text;
      this.operatorValue = value.value;
      this.operatorPopup = false;
    },
    chooseOperator(index) {
      if (this.operatorList.find((v) => v.isSelect)) this.paymentAccount = "";
      this.operatorList.map((v) => {
        v.isSelect = false;
        return v;
      });
      this.operatorList[index].isSelect = true;
    },
    async getResults() {
      let res = await this.$http.checkoutPayResult(this.$route.query.trxNo);
      if (res.code == "200") {
        this.collectionData = res.data;
        this.repaymentData.collectedAmount = this.collectionData.collectedAmount;
        if (this.collectionData.collectedAmount == 0 && this.collectionData.transactionNums == 0) {
          this.collectionDataStep = 0;
        } else {
          this.collectionDataStep = 1;
        }
        this.collectionShow = true;
        // this.collectionDetailShow = true;
      }
    },
    async getCollectedDetail() {
      let res = await this.$http.checkoutPayResult(this.$route.query.trxNo);
      if (res.code == "200") {
        this.collectionData = res.data;
        this.repaymentData.collectedAmount = this.collectionData.collectedAmount;
        if (this.collectionData.collectDetails.length == 0) {
          this.$toast("No details available")
          return;
        }
        if (this.collectionData.collectedAmount == 0 && this.collectionData.transactionNums == 0) {
          this.collectionDataStep = 0;
        } else {
          this.collectionDataStep = 1;
        }
        // this.collectionShow = true;
        this.collectionDetailShow = true;
      }
    },
    async editAccountSubmit() {
      if (!this.editAccountNumber) {
        this.$toast(this.$t("text_please_enter_your_actual_payment_account"));
      }

      let editAccountNumber = this.editAccountNumber;
      if (!this.checkPhone(editAccountNumber)) {
        this.$toast("The format of the mobile phone number is incorrect");
        return;
      }
      //   if(editAccountNumber.startsWith("0")){
      //     editAccountNumber = editAccountNumber.substring(1);
      //   }
      editAccountNumber = this.zeroFill(editAccountNumber);
      editAccountNumber = editAccountNumber.trim();
      // editAccountNumber = "255" + editAccountNumber;
      this.editAccountNumber = editAccountNumber;
      if (this.repaymentData.userSubmitAccountNumber == this.editAccountNumber) {
        this.$toast("The new number must be different from the previous one!")
        return;
      }
      this.editAccountConfirmShow = true;
      // this.debounce(this.submitTrxNo, 1000)();
      // this.submitEditTrxNo();
    },
    async submitEditTrxNo() {
      let res = await this.$http.checkoutPaymentAccount({
        originAccountNumber: this.repaymentData.userSubmitAccountNumber,
        editAccountNumber: this.editAccountNumber,
        trxNo: this.$route.query.trxNo
      });
      if (res.code == "200") {
        await this.$http.checkoutReverseMatch({
          userSubmitAccountNumber: this.editAccountNumber,
          trxNo: this.$route.query.trxNo
        })
        this.$toast("Successfully modified");
        this.editAccountShow = false;
        this.editAccountConfirmShow = false;
        this.$emit("refreshData")
      }
      console.log(res)
    },
    async carrierSelectionSubmit() {
      this.debounce(this.carrierSelection, 1000, false)();
    },
    async carrierSelection() {
      // if(Date.now() > 1){
      //   console.log("点了")
      //   return;
      // }
      // if(this.channelCheckoutUrl){
      //   window.location.href = this.channelCheckoutUrl;
      //   return;
      // }
      let result = await this.$http.v1SdkSysInitialize({
        platformReference: this.$route.params.platformReference,
        // mno: obj.value
      })
      console.log("result", result)
      if (result.data && result.data.channelCheckoutUrl) {
        // this.channelCheckoutUrl = result.data.channelCheckoutUrl;
        this.skipHandle(result.data.channelCheckoutUrl)
      }
    },
    async paymentAccountSubmit() {
      if (this.countryInfo?.enName === "TH") {
        if (!this.customerName) {
          this.$toast(this.$t("text_please_enter_customer_name"));
          return;
        }
        if (!this.customerBankCode) {
          this.$toast(this.$t("text_please_select_bank"));
          return;
        }
        if (!this.paymentAccount) {
          this.$toast(this.$t("text_please_enter_payment_account_number"));
          return;
        }
        this.userSubmitAccountNumber = this.paymentAccount;
        this.submitTrxNo();
        return;
      }

      if (this.operatorList.length) {
        let obj = this.operatorList.find((v) => v.isSelect);
        if (!obj) {
          this.$toast(this.$t("text_please_select_operator_first"));
          return;
        }
        this.userSubmitOperator = obj.name;
      }
      if (this.repaymentData.extraParams.includes("customerAccountNumber")) {
        if (!this.paymentAccount) {
          this.$toast(this.$t("text_please_enter_payment_account_number"));
          return;
        }
      }

      let userSubmitAccountNumber = this.paymentAccount;
      if (!this.checkPhone(userSubmitAccountNumber)) {
        this.$toast(this.$t("text_mobile_phone_number_format_incorrect"));
        return;
      }
      //   if(userSubmitAccountNumber.startsWith("0")){
      //     userSubmitAccountNumber = userSubmitAccountNumber.substring(1);
      //   }
      userSubmitAccountNumber = this.zeroFill(userSubmitAccountNumber);
      userSubmitAccountNumber = userSubmitAccountNumber.trim();
      // userSubmitAccountNumber = "255" + userSubmitAccountNumber;
      this.userSubmitAccountNumber = userSubmitAccountNumber;

      // this.debounce(this.submitTrxNo, 1000)();
      this.submitTrxNo();
    },
    async submitTrxNo() {
      let obj = this.operatorList.find((v) => v.isSelect);
      let res = await this.$http.v1SdkSysInitialize({
        paymentAccountNumber: this.userSubmitAccountNumber,
        platformReference: this.$route.params.platformReference,
        customerBankCode: this.countryInfo?.enName === "TH" ? this.customerBankCode : (obj ? obj.value : undefined),
        customerName: this.countryInfo?.enName === "TH" ? this.customerName : undefined,
      });

      if (res.code == "200") {
        this.$http.checkoutSubmit({
          userSubmitAccountNumber: this.userSubmitAccountNumber,
          trxNo: res.data.repaymentCode,
          platformReference: this.$route.params.platformReference,
          bankCode: this.countryInfo?.enName === "TH" ? undefined : (obj ? obj.value : undefined),
          customerName: this.countryInfo?.enName === "TH" ? this.customerName : undefined,
          customerBankCode: this.countryInfo?.enName === "TH" ? this.customerBankCode : undefined,
        });
        this.paymentAccountShow = false;
        this.$emit("refreshData");

        if (res.data && res.data.channelCheckoutUrl) {
          // this.channelCheckoutUrl = result.data.channelCheckoutUrl;
          this.skipHandle(res.data.channelCheckoutUrl);
        }
      }
    },
    skipHandle(url) {
      if (!url){
        return;
      }
      if(url.includes("cardsdk") && !url.includes("&from=pay")){
        url+="&from=pay"
      }
      window.location.href = url;
    },
    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$toast(this.$t("text_successful_replication"));
      oInput.remove();
    },
    futureDay() {
      clearTimeout(this.setTimeoutID)
      // console.log("futureDay", this.pageData.remainTime)
      const msec = this.pageData.remainTime;
      this.pageData.remainTime -= 1000;
      let day = parseInt(msec / 1000 / 60 / 60 / 24)
      let hr = parseInt(msec / 1000 / 60 / 60 % 24) + (day * 24)
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
      // console.log(hr, min, sec)
      hr > 99 ? hr = 99 : hr
      if (Object.is(hr, NaN) || Object.is(min, NaN) || Object.is(sec, NaN)) {
        hr = 0;
        min = 0;
        sec = 0;
      }
      hr = hr < 0 ? 0 : hr;
      min = min < 0 ? 0 : min;
      sec = sec < 0 ? 0 : sec;
      // this.day = day
      this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : '0' + min
      this.sec = sec > 9 ? sec : '0' + sec

      // this.repaymentData.day = this.day;
      this.repaymentData.hr = this.hr;
      this.repaymentData.min = this.min;
      this.repaymentData.sec = this.sec;
      this.setTimeoutID = setTimeout(() => {
        this.futureDay()
      }, 1000)

      if (!this.pageData.expirationTime) {
        return;
      }
      if (hr == 0 && min == 0 && sec == 0) {
        clearTimeout(this.setTimeoutID)
        this.$emit("expired")
      }
    },
    zeroFill(value) {
      return zeroFillPaymentPhone(value, this.countryInfo);
    },
    checkPhone(value) {
      if (!this.repaymentData.extraParams.includes("customerAccountNumber")) {
        return true;
      }
      return checkPaymentPhone(value, this.countryInfo);
    },
    debounce(func, delay = 1000, immediate = true) {
      let _this = this;
      //不能用箭头函数
      return function () {
        //在时间内重复调用的时候需要清空之前的定时任务
        if (_this.timer) {
          clearTimeout(_this.timer)
        }
        //适用于首次需要立刻执行的
        if (immediate && !_this.timer) {
          func.apply(this, arguments)
        }
        _this.timer = setTimeout(() => {
          func.apply(this, arguments)
        }, delay)
      }
    },
    async init() {
      this.futureDay();
    },
    // 与 DisplayLogic 一致：从 checkout 接口返回的 mnoInfos 构建运营商列表
    initOperatorListFromMnoInfos() {
      if (this.repaymentData?.configData?.checkoutConfigInfoVOList?.mnoInfos?.length) {
        this.repaymentData.configData.checkoutConfigInfoVOList.mnoInfos.forEach((v) => {
          this.operatorList.push({
            name: v.bankInfoVO.bankName,
            value: v.bankInfoVO.bankCode,
            logo: v.bankInfoVO.bankIcon,
            isSelect: false,
            decimalPlaces: v.decimalPlaces,
          });
        });
        // 如果只有一个选项，自动选中
        if (this.operatorList.length === 1) {
          this.operatorList[0].isSelect = true;
        }
        // 如果有多个选项，且接口返回了 bankCode，则根据 bankCode 设置默认选中项
        else if (this.repaymentData?.paymentData?.bankCode) {
          const bankCode = this.repaymentData.paymentData.bankCode;
          const matchedOperator = this.operatorList.find((v) => v.value === bankCode);
          if (matchedOperator) {
            matchedOperator.isSelect = true;
          }
        }
      }
    },
    initOperatorList() {
      this.operatorList = [];
      // AO 不需要选择运营商
      if (this.countryInfo?.enName === "AO") {
        return;
      }
      // CM 市场使用写死的 operatorList
      if (this.countryInfo?.enName === "CM") {
        this.operatorList = [
          {
            name: "MTN",
            value: "CM0001",
            logo: require("@/assets/CM/mtn.png"),
            isSelect: false,
          },
          {
            name: "ORANGE",
            value: "CM0002",
            logo: require("@/assets/CM/orange.png"),
            isSelect: false,
          },
        ];
      } else if (this.countryInfo?.enName === "BD") {
        this.operatorList = [
          {
            name: "bKash",
            value: "BD0001",
            logo: require("@/assets/BD/bKash.png"),
            isSelect: false,
          },
          {
            name: "Nagad",
            value: "BD0002",
            logo: require("@/assets/BD/Nagad.png"),
            isSelect: false,
          },
        ];
      } else {
        this.initOperatorListFromMnoInfos();
      }
    },
    updateCode() {
      applyCountryCurrencyCode(this.repaymentData);
    },
  },
  created() {
    this.repaymentData = this.pageData;
    this.$nextTick(() => {
      console.log('countryInfo:', this.countryInfo);
      console.log('countryCode:', this.countryInfo?.enName);
      this.setLanguageBasedOnCountry(this.countryInfo?.enName);
    });
    this.$forceUpdate();
    this.updateCode();
    if (this.countryInfo?.enName === "TH") {
      this.getBankList();
    }
    this.initOperatorList();
    if (this.repaymentData.extraParams.includes("customerAccountNumber")||this.repaymentData.extraParams.includes("customerBankCode")) {
      this.paymentAccountShow = true;
      // this.carrierSelectionShow = true;
    } else {
      if (this.repaymentData.sdkChannelRespDetailVO && this.repaymentData.sdkChannelRespDetailVO.channelCheckoutUrl) {
        this.skipHandle(
          this.repaymentData.sdkChannelRespDetailVO.channelCheckoutUrl
        );
      } else {
        this.carrierSelection();
      }
    }
    
    // this.carrierSelectionShow = true;
    this.init();
    // this.getResults();
    // this.getCollectedDetail();
    // this.paymentAccountShow = true;
    // this.editAccountShow = true;
    // this.editAccountConfirmShow = true;
  },
  mounted() {
  },
  beforeDestroy() {
    clearTimeout(this.setTimeoutID)
    this.setTimeoutID = null;
  }
};
